import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as o, normalizeClass as n, createElementVNode as e } from "vue";
import { _ as r } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconMondayCom",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(i).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ e("path", {
  d: "M4.488 17.991a2.498 2.498 0 0 1-2.177-1.263 2.415 2.415 0 0 1 .069-2.486l4.482-7.039a2.5 2.5 0 0 1 2.213-1.202 2.494 2.494 0 0 1 2.141 1.32 2.41 2.41 0 0 1-.135 2.482l-4.48 7.04a2.499 2.499 0 0 1-2.113 1.148Z",
  fill: "#F62B54"
}, null, -1), m = /* @__PURE__ */ e("path", {
  d: "M12.176 17.99a2.49 2.49 0 0 1-2.173-1.26 2.408 2.408 0 0 1 .069-2.479l4.473-7.022A2.496 2.496 0 0 1 16.76 6c.912.02 1.738.53 2.156 1.327a2.407 2.407 0 0 1-.162 2.494l-4.473 7.023a2.496 2.496 0 0 1-2.105 1.146Z",
  fill: "#FC0"
}, null, -1), h = /* @__PURE__ */ e("path", {
  d: "M19.693 18.05c1.274 0 2.307-1.012 2.307-2.26 0-1.247-1.033-2.259-2.307-2.259-1.275 0-2.308 1.012-2.308 2.26 0 1.247 1.033 2.259 2.308 2.259Z",
  fill: "#00CA72"
}, null, -1), u = [
  _,
  m,
  h
];
function f(t, p, d, C, b, a) {
  return o(), l("svg", {
    "aria-label": d.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--monday-com"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Monday Com",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, u, 10, c);
}
const M = /* @__PURE__ */ r(s, [["render", f]]);
export {
  M as default
};
//# sourceMappingURL=monday-com.js.map
